"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GLOBAL_DISCLAIMER_STORE_WINDOW_KEY = '__ksysGlobalDisclaimerStore__';
exports.GLOBAL_USER_COUNTRY_KEY = '__ksysUserCountry__';
//# sourceMappingURL=index.js.map